import { themes } from 'contexts/theme-context'

export const themeByWalletClientId = (walletClientId) => {
  const foundTheme = themeList().find(theme => theme.walletClientId === walletClientId)
  return foundTheme
}

export const themeList = () => {
  const themeArray = Object.keys(themes).reduce((accumulator, key) => {
    accumulator.push(themes[key])
    return accumulator
  }, [])
  return themeArray
}



// WEBPACK FOOTER //
// ./src/tools/theme.js